import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  title = 'clientlead';
  currentRoute: string = '';
  path: string = '';
  isDisplayDashboard: boolean = true;

  loggedIn: boolean = false;

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event) => {
      const navEndEvent = event as NavigationEnd;
      this.currentRoute = navEndEvent.url;
      this.checkAuthOnRoute(navEndEvent.url);
    });
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.checkAuthOnRoute(window.location.pathname);
    }
  }

  checkAuthOnRoute(path: string): void {
    const userId = localStorage.getItem('user_id');
    const token = localStorage.getItem('TOKEN');

    const isLoginPage = path === '/login' || path === '/';

    // On the login/root page, never show the sidebar/topbar shell,
    // regardless of what is in localStorage.
    if (isLoginPage) {
      this.loggedIn = false;
      this.path = 'login';
      return;
    }

    this.loggedIn = !!userId && !!token;
    this.path = '';

    if (!this.loggedIn) {
      this.router.navigate(['/login']);
    }
  }
}